import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import {connect} from "react-redux";
import {setTitle} from "../../actions/topHeaderActions";
import ReactSelect from 'react-select';
import {fetchUsers} from "../../actions/jiraActions";
import AuditLogGrid from "../../components/bo-core/grids/AuditLogGrid";
import Utils from "../../Utils";

interface Props extends RouteComponentProps {
    jiraUsers: any;
    jiraUsersIsFetching: boolean;
    title: any;

    fetchUsers(): void;

    setTitle(title: string): void;
}

interface State {
    selectedUser: any;
}

class AuditLog extends React.Component<Props, State> {

    constructor(props) {
        super(props);
        this.state = {
            selectedUser: {
                value: null,
                label: ''
            }
        }
    }


    componentDidMount(): void {
        this.props.fetchUsers();
        this.props.setTitle("Audit Log");
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (this.props.jiraUsers && prevProps.jiraUsers !== this.props.jiraUsers && this.props.jiraUsers.length > 0 &&
            !this.state.selectedUser.value) {
            this.setState({
                selectedUser: {
                    value: '',
                    label: 'All Users'
                }
            });
        }
    }

    handleUserKeyDown = (e) => {
         if (e.keyCode === 9) {
            e.preventDefault();
            document.getElementById('audit-log-search').focus();
        }
        if (e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
    };

    onSelectedUserChange = (item: any) => {
       this.setState({
            selectedUser: {
                value: item.value,
                label: item.label
            }
        });
    };

    render() {
        const {jiraUsers, jiraUsersIsFetching} = this.props;
        const {selectedUser} = this.state;
        if (jiraUsersIsFetching) {
            return null
        }

        const generateUserOptions = () => {
           if (jiraUsers) {
                const arr = jiraUsers.map((val: any) => {
                    return {
                        value: val.username,
                        label: val.firstName
                    }
                });
                arr.unshift({
                    value: '',
                    label: 'All Users'
                });

                return arr;
            }
            return [{
                 value:'',
                 label:"All Users"
            }];
        }

        return <div style={{height: "100%", width: "100%"}} className="bo-core">
            <div style={{
                height: 50,
                marginRight: 0,
                marginLeft: 0,
                display: "flex",
                alignItems: "center"}}
                 className="row bo-core-header top-header">
                <span className="header-title">{this.props.title}</span>
                <div style={{width: 200}}>
                    <ReactSelect
                        id={'selectedUser'}
                        styles={Utils.getReactSelectNewDesign()}
                        onKeyDown={this.handleUserKeyDown}
                        defaultValue={
                            {    
                             value:"All Users",
                             label:"All Users"
                            } 
                          }
                        autoFocus={true}
                        value={this.state.selectedUser}
                        options={generateUserOptions()}
                        onChange={this.onSelectedUserChange}
                        tabIndex={1}
                        theme={theme => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary25: '#5f8c90',
                                primary: '#34585b',
                                primary50: '#5f8c90'
                            },
                        })}
                    />
                </div>
            </div>
            <div style={{height: "calc(100% - 50px)"}}>
                <AuditLogGrid selectedUser={selectedUser}/>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        jiraUsers: state.jira.jiraUsers,
        jiraUsersIsFetching: state.jira.jiraUsersIsFetching,
        title: state.topHeader.title
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchUsers: () => {
            dispatch(fetchUsers());
        },
        setTitle: (title) => {
            dispatch(setTitle(title))
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuditLog))



// WEBPACK FOOTER //
// ./app/views/bo-core/AuditLog.tsx